import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../base.component';

@Component({
	selector: 'result-page-toggle-section',
	templateUrl: './result-page-toggle-section.component.html',
	styleUrls: ['./result-page-toggle-section.component.scss'],
})
export class ResultPageToggleSectionComponent extends BaseComponent implements OnInit {
	toggleFirstSelected: boolean = true;

	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		this.storeService.setGlobalAttribute('showInfoBlocks', true);
		this.layoutService.globalAttributes.subscribe((data) => {
			this.toggleFirstSelected = data['showInfoBlocks'];
		});
	}

	viewCoverages() {
		this.storeService.setGlobalAttribute('showInfoBlocks', true);
		this.storeService.setGlobalAttribute('shouldFireCompareRatesGaEvent', false);
		this.storeService.setGlobalAttribute('showComparison', false);
	}

	viewComparison() {
		this.storeService.setGlobalAttribute('showComparison', true);
		this.storeService.setGlobalAttribute('shouldFireCompareRatesGaEvent', true);
		this.storeService.setGlobalAttribute('showInfoBlocks', false);
	}
}
